import { createWebHistory, createRouter } from "vue-router";
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
import NewUser from "./components/NewUser.vue";
import NewTest from "./components/NewTest";
import PasswordGet from "./components/PasswordGet.vue";
import PasswordReset from "./components/PasswordReset.vue";
// lazy-loaded
const Profile = () => import("./components/Profile.vue");
const DashAdmin = () => import("./components/DashAdmin.vue");
const DashUser = () => import("./components/DashUser.vue");
const TestRuns = () => import("./components/TestRuns.vue");
const JsonReport = () => import("./components/JsonReport.vue");
const DeleteReport = () => import("./components/DeleteReport.vue");
const BuildFrameworks = () => import("./components/BuildFrameworks.vue");
const Mock = () => import("./components/Mock.vue");

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/newuser",
    component: NewUser,
  },

  {
    path: "/register",
    component: Register,
  },

  {
    path: "/newtest",
    component: NewTest,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: PasswordGet,
  },
  {
    path: "/reset",
    name: "reset",
    component: PasswordReset,
  },
  {
    path: "/profile",
    name: "profile",
    // lazy-loaded
    component: Profile,
  },

  {
    path: "/testruns",
    name: "testruns",
    component: TestRuns,
  },

  {
    path: "/jsonreport",
    name: "jsonreport",
    component: JsonReport,
  },

  {
    path: "/delreport",
    name: "delreport",
    component: DeleteReport,
  },

  {
    path: "/admin",
    name: "admin",
    // lazy-loaded
    component: DashAdmin,
  },

  {
    path: "/user",
    name: "user",
    // lazy-loaded
    component: DashUser,
  },

  {
    path: "/buildframeworks",
    name: "buildframeworks",
    // lazy-loaded
    component: BuildFrameworks,
  },

  {
    path: "/mock",
    name: "mock",
    // lazy-loaded
    component: Mock,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login", "/register", "/home", "/forgot", "/reset"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
